import { push as pushToHistory } from 'connected-react-router';

export * from './attachment-actions';
export * from './configuration-actions';
export * from './issues-actions';
export * from './pushpin-actions';
export * from './workflows-actions';
export * from './reports-actions';
export * from './analytics-actions';
export * from './issue-preview-actions';

export const SET_FF_LOADED = 'SET_FF_LOADED';
export const ACCESS_TOKEN_SET = 'ACCESS_TOKEN_SET';
export const TARGET_URN_SET = 'TARGET_URN_SET';
export const CURRENT_USER_FETCH_START = 'CURRENT_USER_FETCH_START';
export const CURRENT_USER_FETCH_API = 'CURRENT_USER_FETCH_API';
export const CURRENT_USER_FETCH_API_PENDING = 'CURRENT_USER_FETCH_API_PENDING';
export const CURRENT_USER_FETCH_API_FULFILLED = 'CURRENT_USER_FETCH_API_FULFILLED';
export const CURRENT_USER_FETCH_API_REJECTED = 'CURRENT_USER_FETCH_API_REJECTED';
export const CURRENT_DOCS_PROJECT_FETCH_START = 'CURRENT_DOCS_PROJECT_FETCH_START';
export const CURRENT_DOCS_PROJECT_FETCH_FINISHED = 'CURRENT_DOCS_PROJECT_FETCH_FINISHED';
export const CURRENT_DOCS_PROJECT_FETCH_FAILED = 'CURRENT_DOCS_PROJECT_FETCH_FAILED';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const QUERY_PARAMS_SET = 'QUERY_PARAMS_SET';
export const SET_QUERY_PARAMS_FROM_URL = 'SET_QUERY_PARAMS_FROM_URL';
export const SAVE_ISSUE = 'SAVE_ISSUE';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const RESET_NOTIFICATION = 'RESET_NOTIFICATION';
export const ROUTE_CHANGE = 'ROUTE_CHANGE';
export const HANDLE_NAVIGATE_TO_RFI_IN_DOCUMENT = 'HANDLE_NAVIGATE_TO_RFI_IN_DOCUMENT';
export const SHEET_CHANGE = 'SHEET_CHANGE';
export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';
export const OPEN_PUSHPIN_SELECTION = 'OPEN_PUSHPIN_SELECTION';
export const CLOSE_PUSHPIN_SELECTION = 'CLOSE_PUSHPIN_SELECTION';
export const SET_PACKAGE_DEEPLINKING_FALSE = 'SET_PACKAGE_DEEPLINKING_FALSE';
export const PERMISSIONS_VIOLATION_FOUND = 'PERMISSIONS_VIOLATION_FOUND';
export const BIND_REDISPATCH_EVENT = 'BIND_REDISPATCH_EVENT';
export const OPEN_IFRAME = 'OPEN_IFRAME';
export const CLOSE_IFRAME = 'CLOSE_IFRAME';

/**
 * These are action-creators -- they return an action, for the store to dispatch:
 */

export const setFFLoaded = () => ({
  type: SET_FF_LOADED,
});

export const setAccessTokenAction = (token) => {
  return {
    type: ACCESS_TOKEN_SET,
    payload: token,
  };
};

export const setTargetUrnAction = (targetUrn) => {
  return {
    type: TARGET_URN_SET,
    payload: targetUrn,
  };
};

export const changeLocationAction = (route) => {
  return pushToHistory(route);
};

export const fetchCurrentUserAction = () => {
  return {
    type: CURRENT_USER_FETCH_START,
  };
};

export const setCurrentProject = (analyticsConfig) => {
  return {
    type: SET_CURRENT_PROJECT,
    payload: analyticsConfig,
  };
};

export const fetchCurrentDocsProjectAction = () => {
  return {
    type: CURRENT_DOCS_PROJECT_FETCH_START,
  };
};

export const currentProjectFetchFinished = (project) => {
  return {
    type: CURRENT_DOCS_PROJECT_FETCH_FINISHED,
    payload: project,
  };
};

export const currentProjectFetchFailed = (error) => {
  return {
    type: CURRENT_DOCS_PROJECT_FETCH_FAILED,
    payload: error,
  };
};


export const setQueryParamsAction = (queryParams) => {
  return {
    type: QUERY_PARAMS_SET,
    payload: queryParams,
  };
};

export const setQueryParamsFromUrlAction = (queryParams, currentView, newLocation) => {
  return {
    type: SET_QUERY_PARAMS_FROM_URL,
    payload: { queryParams, currentView, newLocation },
  };
};

export const saveIssueAction = (issue, onSuccess, onError) => {
  return {
    type: SAVE_ISSUE,
    payload: { issue, onSuccess, onError },
  };
};

export const showNotificationAction = (notification) => {
  return {
    type: SHOW_NOTIFICATION,
    payload: notification,
  };
};

export const resetNotification = () => {
  return {
    type: RESET_NOTIFICATION,
  };
};

export const routeChangeEventTriggerAction = (pathname, params) => {
  return {
    type: ROUTE_CHANGE,
    payload: { pathname, params },
  };
};

export const navigateToIssueInDocumentAction = (targetUrn, issueId, location) => {
  return {
    type: HANDLE_NAVIGATE_TO_RFI_IN_DOCUMENT,
    payload: { targetUrn, issueType: 'rfis', issueId, location },
  };
};

export const sheetChangeAction = (newSheetGuid) => {
  return {
    type: SHEET_CHANGE,
    payload: newSheetGuid,
  };
};

export const setCurrentViewAction = (view) => {
  return {
    type: SET_CURRENT_VIEW,
    payload: view,
  };
};

export const tokenExpired = () => {
  return {
    type: TOKEN_EXPIRED,
  };
};

export const openPushpinSelection = (document, status, location) => {
  return {
    type: OPEN_PUSHPIN_SELECTION,
    payload: {
      document,
      status,
      location,
    },
  };
};

export const closePushpinSelection = (location) => {
  return {
    type: CLOSE_PUSHPIN_SELECTION,
    payload: {
      location,
    },
  };
};

export const permissionsViolation = (config) => {
  return {
    type: PERMISSIONS_VIOLATION_FOUND,
    payload: { config },
  };
};

export const setPackageDeepLinkingFalse = () => ({ type: SET_PACKAGE_DEEPLINKING_FALSE });

export const bindRedispatchEvent = (eventName, eventHandler) => {
  return {
    type: BIND_REDISPATCH_EVENT,
    payload: { eventName, eventHandler },
  };
};


export const openIframeModal = (url, title) => ({
  type: OPEN_IFRAME,
  payload: { url, title },
});


export const closeIframeModal = () => ({
  type: CLOSE_IFRAME,
});
